import { render, staticRenderFns } from "./cardTemplateVip13.vue?vue&type=template&id=3d1f7c36&scoped=true&"
import script from "./cardTemplateVip13.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip13.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip13.vue?vue&type=style&index=0&id=3d1f7c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f7c36",
  null
  
)

export default component.exports